<template>
  <div>
    <h3 class="page-heading">API Calls</h3>
    <div id="content">
      <div v-if="section === 'socialmedia'">
        <socialmedia></socialmedia>
      </div>
      <div v-else-if="section === 'personality'">
        <personality></personality>
      </div>
      <div v-else-if="section === 'photo'">
        <photo></photo>
      </div>
      <div v-else-if="section === 'news'">
        <news></news>
      </div>
      <div v-else-if="section === 'voice'">
        <voice></voice>
      </div>
    </div>
    <div>
      <v-bottom-nav
        :active.sync="section"
        :value="true"
        fixed
        v-model="section"
      >
        <v-btn
          color="teal"
          flat
          value="socialmedia"
        >
          <span>Social Media</span>
          <v-icon>group</v-icon>
        </v-btn>

        <v-btn
          color="teal"
          flat
          value="personality"
        >
          <span>Personality</span>
          <v-icon>mood</v-icon>
        </v-btn>

        <v-btn
          color="teal"
          flat
          value="photo"
        >
          <span>Photo</span>
          <v-icon>photo</v-icon>
        </v-btn>

        <v-btn
          color="teal"
          flat
          value="news"
        >
          <span>News</span>
          <v-icon>location_city</v-icon>
        </v-btn>
        <v-btn
          color="teal"
          flat
          value="voice"
        >
          <span>Voice</span>
          <v-icon>record_voice_over</v-icon>
        </v-btn>
      </v-bottom-nav>
    </div>
  </div>
</template>

<script>
  import Socialmedia from '../components/user-class/socialMedia'
  import Usertables from '../components/user-class/userTables'
  import Personality from '../components/user-class/personality'
  import Photo from '../components/user-class/photo'
  import News from '../components/user-class/news'
  import Voice from '../components/user-class/voice'

  export default {
    name: 'UserClass',
    components: {Voice, News, Photo, Personality, Usertables, Socialmedia},
    data: () => ({
      section: 'socialmedia',
      titles: {
        socialmedia: 'Social Media',
        personality: 'Personality',
        news: 'News',
        photo: 'Photo'
      }
    })
  }
</script>

<style scoped>
  #content {
    padding-bottom: 55px;
  }
</style>



// WEBPACK FOOTER //
// src/views/UserClass.vue